import { render } from "./Item3.vue?vue&type=template&id=6fb0b8d2&ts=true"
import script from "./Item3.vue?vue&type=script&lang=ts"
export * from "./Item3.vue?vue&type=script&lang=ts"

import exportComponent from "/home/sensores-test/frontendv2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__